import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { clearPurpose } from "../utils/Purpose";
import Message from './Message';
import React, { useEffect, useState } from 'react';
import { env } from '../env'

export default function FormAlreadyCompleted(props) {

    // Declare variables using const or let
    const { session, storageValues } = props; 

    const [isMessageRequried, setIsMessageRequired] = useState(false);
        
    // Declare effects using useEffect
    useEffect(() => {
        document.title = 'CPA - Completed';
    }, []);

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormAlreadyCompleted.useEffect :: []`);
        }

        clearPurpose(storageValues);
        if (session && session.submittedUrl) {
            window.location.href = session.submittedUrl;
        }
        else {
            setIsMessageRequired(true);
        }
    }, []);

    return (
            <div className="row">
                <div className="e-card">
                    <div className="e-card-content">
                    <div className="col-xs-12 mt-2">
                        {isMessageRequried && (
                            <MessageComponent severity="Info" variant="Outline" content="This campaign has already been submitted, Thank you for supporting this campaign, you may close the browser."></MessageComponent >
                        )} : <Message value="This campaign has already been submitted, Redirecting..." />
                    </div>
                </div>
            </div>
        </div>
    );
}
